import { BackArrowIcon, ProfileIcon, ShareIcon } from "../../Assets/assets";
import chennaiCorporationLogo from "../../Assets/chennaiCorporationLogo.png";
import "./Header.css";

export default function Header(props) {
  return (
    <div
      className={`${
        props.theme === "dark"
          ? "background-color-primary"
          : "background-color-primary"
      } height-64px inherit-parent-width display-flex flex-align-items-center padding-large`}
    >
      <div className="flex-justify-content-space-between inherit-parent-width">
        <div className="display-flex flex-align-items-center flex-justify-content-center">
          {props.backOnClick && (
            <div
              style={{
                width: "20px",
                height: "20px",
                cursor: "pointer"
              }}
              data-cy="back-arrow-icon"
              className="display-flex flex-align-items-center flex-justify-content-center"
              onClick={props.backOnClick}
            >
              <BackArrowIcon
                width="20"
                height="20"
                color={props.theme === "dark" ? "#FFFFFF" : "#3E3E3E"}
              />
            </div>
          )}

          {!props.backOnClick && (
            <img
              src={chennaiCorporationLogo}
              alt="chennai-corporation-logo"
              width="30px"
            />
          )}

          <div
            style={{
              color: props.theme === "dark" ? "#FFFFFF" : "#3E3E3E"
            }}
            className="padding-left-default text-capitalize"
          >
            {props.title}
          </div>
        </div>

        {props.profileOnClick && (
          <div
            data-cy="profile-icon"
            style={{ width: "30px", height: "40px" }}
            onClick={props.profileOnClick}
          >
            <ProfileIcon
              height="40px"
              width="30px"
              color="var(--tertiaryColor4)"
            />
          </div>
        )}
        {typeof props.shareOnclick === "function" ? (
          <div
            data-cy="share-icon"
            onClick={props.shareOnclick}
            style={{ width: "18px", height: "18px" }}
          >
            <ShareIcon height="18px" width="18px" color="#3E3E3E" />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
